import { BookOpen, Database, Code, Network, Table, BarChart, Info, Edit } from 'lucide-react';
import type { ReactNode } from 'react';

export interface DetailTab {
  id: string;
  label: string;
  icon: ReactNode;
}

/**
 * Configuration for detail page tabs by section
 */
export const detailTabsBySection: Record<string, DetailTab[]> = {
  // Primitives/Configs - Full schema and data browser
  configs: [
    { id: 'overview', label: 'Overview', icon: <BookOpen className="h-4 w-4" /> },
    { id: 'schema', label: 'Schema', icon: <Database className="h-4 w-4" /> },
    { id: 'operations', label: 'Operations', icon: <Code className="h-4 w-4" /> },
    { id: 'graph', label: 'Relationships', icon: <Network className="h-4 w-4" /> },
    { id: 'data', label: 'Data', icon: <Table className="h-4 w-4" /> },
    { id: 'stats', label: 'Stats', icon: <BarChart className="h-4 w-4" /> },
  ],
  
  // Players - Profile and data
  players: [
    { id: 'overview', label: 'Overview', icon: <Info className="h-4 w-4" /> },
    { id: 'edit', label: 'Edit', icon: <Edit className="h-4 w-4" /> },
  ],
  
  // Worlds - Configuration and data
  worlds: [
    { id: 'overview', label: 'Overview', icon: <Info className="h-4 w-4" /> },
    { id: 'edit', label: 'Edit', icon: <Edit className="h-4 w-4" /> },
  ],
  
  // Characters - Profile and relationships
  characters: [
    { id: 'overview', label: 'Overview', icon: <Info className="h-4 w-4" /> },
    { id: 'edit', label: 'Edit', icon: <Edit className="h-4 w-4" /> },
  ],
  
  // Packs - Contents and metadata
  packs: [
    { id: 'overview', label: 'Overview', icon: <Info className="h-4 w-4" /> },
    { id: 'edit', label: 'Edit', icon: <Edit className="h-4 w-4" /> },
  ],
  
  // Templates - Structure and usage
  templates: [
    { id: 'overview', label: 'Overview', icon: <Info className="h-4 w-4" /> },
    { id: 'edit', label: 'Edit', icon: <Edit className="h-4 w-4" /> },
  ],
  
  // Art - Preview and metadata
  art: [
    { id: 'overview', label: 'Overview', icon: <Info className="h-4 w-4" /> },
    { id: 'edit', label: 'Edit', icon: <Edit className="h-4 w-4" /> },
  ],
  
  // Music - Playback and metadata
  music: [
    { id: 'overview', label: 'Overview', icon: <Info className="h-4 w-4" /> },
    { id: 'edit', label: 'Edit', icon: <Edit className="h-4 w-4" /> },
  ],
  
  // Games - Status and configuration
  games: [
    { id: 'overview', label: 'Overview', icon: <Info className="h-4 w-4" /> },
    { id: 'edit', label: 'Edit', icon: <Edit className="h-4 w-4" /> },
  ],
  
  // AI - Runs and configuration
  ai: [
    { id: 'overview', label: 'Overview', icon: <Info className="h-4 w-4" /> },
  ],
  
  // Settings - Configuration
  settings: [
    { id: 'overview', label: 'Overview', icon: <Info className="h-4 w-4" /> },
    { id: 'edit', label: 'Edit', icon: <Edit className="h-4 w-4" /> },
  ],
};

/**
 * Get detail tabs for a specific section
 */
export function getDetailTabs(section: string): DetailTab[] {
  return detailTabsBySection[section] || [];
}

